/** zh-CN catalogue `perf` (W3-09; English: src/render/frame/perf.messages.ts; terms: docs/i18n/glossary.md).
 * The dev performance overlay draws this catalogue's English text (it runs outside React and the i18n runtime);
 * the zh-CN entries keep the one-catalogue-per-English-namespace rule of test/i18n/zhCN.test.ts and are ready
 * if the overlay ever goes through the runtime. */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'perf',
  locale: 'zh-CN',
  messages: {
    title: '帧耗时明细',
    fps: '{fps} fps',
    frame: '帧 {ms} 毫秒（最差 {worst} 毫秒）',
    view: '{name} {ms} 毫秒',
    longTasks: '长任务 {ms} 毫秒/秒',
    idle: '空闲（无帧）',
    preview: '预览 GL 提交 {cpu} 毫秒，GPU {gpu} 毫秒，缩放 {scale}，{quads} 个四边形，{w}x{h}',
    none: '-',
  },
};

export default catalog;
